import { render, staticRenderFns } from "./FieldTagInput.vue?vue&type=template&id=1e51f50d&scoped=true&"
import script from "./FieldTagInput.vue?vue&type=script&lang=ts&"
export * from "./FieldTagInput.vue?vue&type=script&lang=ts&"
import style0 from "./FieldTagInput.vue?vue&type=style&index=0&id=1e51f50d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e51f50d",
  null
  
)

export default component.exports